export function isFormServiceAPIPayloadLengthValid(payload = {}) {
	if (!Object.keys(payload).length || typeof payload !== 'object') {
		return false;
	}
	const maxLength = 4000; // Chars
	return JSON.stringify(payload).length < maxLength;
}
